// Vendors
import $ from 'jquery';
import Cookies from 'js-cookie';

$('.user__country').click(function(e) {
  e.preventDefault();

  const countryCode = $(this).attr('data-country-code');
  const country = $(this).attr('data-country');
  const nonce = $(this).attr('data-nonce');
  const region = $('.region__dropdown');

  const data = {
    action: 'post_user_country',
    country_code: countryCode,
    country: country,
    nonce: nonce,
  };
  const url = '/wp-admin/admin-ajax.php?action=post_user_country';
  Cookies.set('country_code', countryCode, { expires: 365, path: '/' });
  $.ajax({
    type: 'POST',
    dataType: 'json',
    url: url,
    data: data,
    success: response => {
      let output = '';

      output = `${country} <i class='fa fa-caret-down' aria-hidden='true'></i>`;
      region.empty();
      region.append(output);

      return response;
    },
    complete: () => {
      // Reload the page after ajax requests is completed
      document.location.reload();
    },
  });
});
